const INTER_WEIGHTS = [
  { weight: 400, file: 'inter-v13-latin-regular' },
  { weight: 500, file: 'inter-v13-latin-500' },
  { weight: 600, file: 'inter-v13-latin-600' },
]

export const interFontFaces = INTER_WEIGHTS.map(({ weight, file }) => ({
  '@font-face': {
    fontDisplay: 'swap',
    fontFamily: "'Inter'",
    fontStyle: 'normal',
    fontWeight: weight,
    src: `url('/fonts/Inter/${file}.woff2') format('woff2')`,
  },
}))
